import { Button, Intent, Menu, MenuItem, Popover } from "@blueprintjs/core";
import initialState from "core/reducers/initialState";
import LayoutUtil from "core/util/LayoutUtil";
import UrlUtil from "core/util/UrlUtil";
import { IFieldProps } from "decorator-form";
import React from "react";
import { connect } from "react-redux";

/**
 * connected widget for selecting a path of panel instances from pages.
 *
 * @author chris
 */

interface IPagePathFieldStateProps {
	layout: string[];
	panels: {
		[instance: string]: object;
	};
}

type ResultProps = IPagePathFieldStateProps & IFieldProps<string[]>;

function mapStateToProps(state: typeof initialState = initialState): IPagePathFieldStateProps {

	return {
		layout: state.layout,
		panels: state.config.panels
	};
}

class PagePathField extends React.PureComponent<ResultProps> {

	public static getLink(
		panels: { [instance: string]: any; },
		path: string[]
	): string | undefined {

		// return undefined if no/empty path or if any ids are invalid
		if (!path || path.length < 1 || path.find((inst) => !panels[inst])) {
			return undefined;
		}

		return UrlUtil.getLink(...path.map((inst) => panels[inst].path));
	}

	public render() {

		if (!this.props.panels) {
			return <Button minimal={true} disabled={true} text="No Pages Configured" />;
		}

		const url = this.props.formData ? PagePathField.getLink(this.props.panels, this.props.formData) : undefined;

		return (
			<Popover
				autoFocus={false}
				content={
					<Menu>
						{this.props.layout && this.props.layout.map((lid) => {

							return LayoutUtil.findDescendents(this.props.panels, lid, ['page'], true)
										.map((did) => this.renderMenuItem(did));
						})}
					</Menu>
				}
			>
				<Button
					intent={this.props.formData ? (url ? Intent.SUCCESS : Intent.DANGER) : Intent.NONE}
					text={this.props.formData ? PagePathField.getLink(this.props.panels, this.props.formData) || "Invalid Page Path!" : "Nothing Selected"}
				/>
			</Popover>
		);
	}

	private renderMenuItem = (instance: string, ancestors: string[] = []) => {

		const panel = this.props.panels[instance];

		if (!panel) {
			return null;
		}

		const descendantPages = LayoutUtil.findDescendents(this.props.panels, instance, ['page'], true);

		const path = [...ancestors, instance];

		return (
			<MenuItem
				key={instance}
				text={panel['__editName'] || panel['editName'] || "Untitled Page"}
				label={`(${panel['path']})`}
				active={this.props.formData ? this.props.formData.indexOf(instance) > -1 : false}
				onClick={() => {
					this.props.onChange(path);
				}}
			>
				{descendantPages.length > 0 ? descendantPages.map((did) => this.renderMenuItem(did, path)) : undefined}
			</MenuItem>
		);
	}
}

export default connect(mapStateToProps)(PagePathField);



// WEBPACK FOOTER //
// ./src/common/form/fields/PagePathField.tsx